module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_03@1.d524fcaa.png";